<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Manageri flote"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="true"
              />
            </div>
          </template>
            <div class="filtre">
              <el-form @submit.prevent.native="refresh_info()">
                <el-row style="margin: 10px" class="input-group">
                  <el-col class="input-element">
                    <el-form-item label="Nume">
                      <el-input v-model="Filters.Nume" class="full-width"/>
                    </el-form-item>
                  </el-col>  
                  <el-col class="input-element">
                    <el-form-item label="Prenume">
                      <el-input v-model="Filters.Prenume" class="full-width"/>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24">
                    <el-button
                      type="primary"
                      native-type="submit"
                      @click="refresh_info()"
                    >
                      Aplica
                    </el-button>
                    <el-button type="danger" native-type="submit" @click="reset()">
                      Reseteaza
                    </el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="Results">
      
      <el-table-column prop="Id" label="#" width="44px" />
      <el-table-column prop="Nume" label="Nume"/>
      <el-table-column prop="Prenume" label="Prenume"/>
      <el-table-column prop="Email" label="Email" />
      <el-table-column prop="Telefon" label="Telefon"/>
      <el-table-column prop="NumeFirma" label="Firma"/>
      <el-table-column fixed="right" label="Actiuni" width="250px">
        <template slot-scope="scope">
           <el-tooltip content="Vezi istoric">
            <el-button size="small"
              type="info"
              icon="el-icon-right"
              circle
              @click="deschide_link(scope.row)"
              />
          </el-tooltip>    
          <el-tooltip content="Vezi programari viitoare">
            <el-button
              class="butonReg"
              icon="el-icon-view"
              circle
              @click="deschide_link_programari(scope.row)"
              />
          </el-tooltip>       
          <el-tooltip content="Copiaza link in clipboard">
            <el-button size="small"
              type="info"
              icon="el-icon-document-copy"
              circle
              @click="copiaza_link(scope.row)"
              />
          </el-tooltip>
          
          <el-tooltip content="Modificare">
            <el-button size="small"
              type="primary"
              icon="el-icon-edit"
              circle
              @click="show_dialog(scope.row.Id)"
            />
          </el-tooltip>

          <el-tooltip content="Sterge">
            <el-button size="small"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="delete_item(scope.row)"
            /> </el-tooltip></template></el-table-column
    ></el-table>
    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager" />
    <Manageri-flote-dialog class="custom-width" ref="dlg" @save="refresh_info()"
  /></base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Manageri_flote_dialog from "@/pages/Admin/flote/Manageri_flote_dialog.vue";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "manageri_flote",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "Manageri-flote-dialog": Manageri_flote_dialog,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      Results: [],
      base_url: "",
      Info: {},
      Filters: {
        Nume: "",
        Prenume: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },

  
  methods: {
    async get_info() {
      var response = await this.post("admin/flote/get_info_manageri");
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("admin/flote/index_manageri", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("flote");
    },
    reset() {
      this.Filters = {
        Nume: "",
        Prenume: "",
      };
      this.refresh_info();
    },

    async delete_item(item) {
      var confirm = await this.$confirm(`Sunteti sigur ?`, "Warning");
      if (confirm) {
        await this.post("admin/flote/delete_item_manager", { id: item.Id });
        this.refresh_info();
      }
    }, 

    async deschide_link_programari(item){
      try {
          window.open( settings.BASE_PROGRAMARI_FRONTEND_URL + "#/programari_viitoare/" + item.Md5Mail,'_blank')
      } catch (error) {
        console.error(error)
      }
    },
    
    deschide_link(item) {
      window.open( settings.BASE_PROGRAMARI_FRONTEND_URL + "#/istoric/" + item.Md5Mail,'_blank')
    },    


    async copiaza_link(item) {
        try {
        await navigator.clipboard.writeText(settings.BASE_PROGRAMARI_FRONTEND_URL + "#/istoric/"+item.Md5Mail);
        this.$message({ message: 'Linkul a fost adaugat in clipboard!', type: 'success' });
      } catch($e) {
        this.$message({ message: 'Eroare', type: 'danger' });
      }
    
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right("Management") && !this.$has_right("Supervizor")) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  margin-right: 5%;
  width: 45%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
